// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/opt/buildhome/repo/src/models/global';
import model_2 from '/opt/buildhome/repo/src/models/itemDefs';
import model_7 from '/opt/buildhome/repo/src/models/ui';
import model_8 from '/opt/buildhome/repo/src/.umi-production/plugin-initialState/@@initialState';
import model_4 from '/opt/buildhome/repo/src/models/sponsorLeaderboards';
import model_5 from '/opt/buildhome/repo/src/models/sponsors';
import model_3 from '/opt/buildhome/repo/src/models/itemDefsWithSponsorAndLeaderboard';
import model_6 from '/opt/buildhome/repo/src/models/stats';

export const models = {
model_1: { namespace: 'global', model: model_1 },
model_2: { namespace: 'itemDefs', model: model_2 },
model_7: { namespace: 'ui', model: model_7 },
model_8: { namespace: '@@initialState', model: model_8 },
model_4: { namespace: 'sponsorLeaderboards', model: model_4 },
model_5: { namespace: 'sponsors', model: model_5 },
model_3: { namespace: 'itemDefsWithSponsorAndLeaderboard', model: model_3 },
model_6: { namespace: 'stats', model: model_6 },
} as const
